/**
 * Handle Redirect component
 * Created on : 16-06-2025
 */
//  Internal imports
import { loginRequest } from "./authConfig";
import msalInstance from "./msalInstance";

// Handle Autentication Request
const HandleRedirect = () => {
  msalInstance
    .loginRedirect({
      ...loginRequest,
      prompt: "create",
    })
    .catch((error) => {
      // Error
    });
};

export default HandleRedirect;
